// Runtime configuration loader.
//
// /config.js sets window.__APP_CONFIG__ before the React bundle runs (see
// index.html). In production the .NET host generates it from IConfiguration; in
// local dev it is served from public/config.js (copy public/config.example.js).
// Keeping the values out of the bundle is what lets one built artifact be
// promoted between environments unchanged.

export interface FirebaseConfig {
  apiKey: string
  authDomain: string
  projectId: string
  storageBucket: string
  messagingSenderId: string
  appId: string
}

export interface AppConfig {
  firebase: FirebaseConfig
}

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig
  }
}

function readAppConfig(): AppConfig {
  const cfg = window.__APP_CONFIG__
  if (!cfg) {
    throw new Error(
      'App config not loaded. Expected /config.js to set window.__APP_CONFIG__ before the bundle ran. For local dev, create apps/asf-fin-heatmap-web/public/config.js from public/config.example.js.',
    )
  }
  const required: ReadonlyArray<keyof FirebaseConfig> = [
    'apiKey',
    'authDomain',
    'projectId',
    'storageBucket',
    'messagingSenderId',
    'appId',
  ]
  for (const key of required) {
    if (!cfg.firebase?.[key]) {
      throw new Error(`Missing required firebase config field: ${key}`)
    }
  }
  return cfg
}

export const appConfig: AppConfig = readAppConfig()
